import { render, staticRenderFns } from "./BundleProducts.vue?vue&type=template&id=3bd655e4&"
import script from "./BundleProducts.vue?vue&type=script&lang=js&"
export * from "./BundleProducts.vue?vue&type=script&lang=js&"
import style0 from "./BundleProducts.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BundleProduct: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/BundleProduct.vue').default})
